import * as React from "react";
import { map } from "lodash";
import { Button, Alignment, Menu } from "@blueprintjs/core";
import { Select2 } from "@blueprintjs/select";
import { MenuItem2 } from "@blueprintjs/popover2";

import { Dimension } from "../../types/models";

interface IProps {
  onSelectDimension: (dimension: Dimension) => void;
  selectedDimension?: Dimension;
  disabled?: boolean;
  dimensionsByClientId: any[]
}

interface IState {
  dimensionQuery: string;
}

export class DimensionSelector extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      dimensionQuery: "",
    };
  }

  private itemPredicate = (query: string, item: Dimension) => {
    const normalizedQuery = query.toLowerCase();
    return item.Name.toLowerCase().includes(normalizedQuery);
  };

  public render() {
    const { selectedDimension, disabled, dimensionsByClientId } = this.props;
    return (
      <Select2<Dimension>
        items={dimensionsByClientId}
        noResults={<MenuItem2 disabled={true} text="No dimensions found" />}
        itemListRenderer={(itemListProps) => {
          const filteredItems = itemListProps.items.filter((item) =>
            item.Name.toLowerCase().includes(this.state.dimensionQuery.toLowerCase())
          );
          return (
            <Menu ulRef={itemListProps.itemsParentRef}>
              {filteredItems.length > 0 ? (
                map(filteredItems, (item, index) =>
                  itemListProps.renderItem(item, index)
                )
              ) : (
                <MenuItem2 disabled={true} text="No dimensions found" />
              )}
            </Menu>
          );
        }}
        itemRenderer={(dimension, { modifiers, handleClick }) => (
          <MenuItem2
            active={modifiers.active}
            key={dimension.id}
            onClick={handleClick}
            text={dimension.Name}
            style={{ maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis" }}
        />
        )}
        onItemSelect={(dimension) => {
          this.props.onSelectDimension(dimension);
          this.setState({ dimensionQuery: "" });
        }}
        onQueryChange={(query) =>
          this.setState({ dimensionQuery: query })
        }
        filterable={true}
        resetOnClose={true}
        popoverProps={{ matchTargetWidth: true }}
        disabled={disabled}
      >
        <Button
          fill={true}
          alignText={Alignment.LEFT}
          rightIcon="caret-down"
          disabled={disabled}
          text={selectedDimension?.Name || "Select..."}
          style={{ minWidth: "200px", margin: '0 12px' }}
        />
      </Select2>
    );
  }
}
